import { css, unsafeCSS } from 'lit';
import { sbkCoreBreakpointMd } from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const facet2 = css`
  :host {
    --clip-path-facet-2--default: polygon( 11.1% 20.55%,42.225% 2.575%,42.225% 2.575%,43.703% 1.826%,45.234% 1.243%,46.804% 0.827%,48.401% 0.577%,50.009% 0.494%,51.617% 0.577%,53.211% 0.827%,54.778% 1.243%,56.303% 1.826%,57.775% 2.575%,81.125% 16.05%,81.125% 16.05%,82.515% 16.952%,83.786% 17.984%,84.932% 19.135%,85.946% 20.394%,86.822% 21.747%,87.553% 23.183%,88.133% 24.691%,88.555% 26.259%,88.813% 27.874%,88.9% 29.525%,88.9% 65.475%,29.975% 99.5%,11.1% 88.525%,11.1% 20.55% );
    --clip-path-facet-2--mobile: polygon(100% 0%, 0% 0%, 0.03% 81.11%, 24.33% 100%, 100% 41.59%);

    --facet-2__clip-path--mobile: var(--_facet-2__clip-path--mobile, var(--clip-path-facet-2--mobile));
    --facet-2__aspect-ratio--mobile: var(--_facet-2__aspect-ratio--mobile, 4 / 3);
    --facet-2__width--mobile: var(--_facet-2__width--mobile, inherit);
    --facet-2__margin--mobile: var(--_facet-2__margin--mobile, 0);

    --facet-2-md__display--md: var(--_facet-2-md__display--md, block);
    --facet-2-lg__display--md: var(--_facet-2-lg__display--md, none);
    --facet-2-md__display--lg: var(--_facet-2-md__display--lg, none);
    --facet-2-lg__display--lg: var(--_facet-2-lg__display--lg, block);
      
    --facet-2__width: 100%;
    --image__facet-2__margin: var(--_image__facet-2__margin, var(--facet-2__margin));
    --image__facet-2__width: var(--_image__facet-2__width, var(--facet-2__width));
    --image__facet-2__margin--xl: var(--_image__facet-2__margin--xl, var(--facet-2__margin));
    --image__facet-2__width--xl: var(--_image__facet-2__width--xl, var(--facet-2__width));

    --facet-2__onDark: var(--_facet-2__onDark, none);
    --facet-2__onDark--xl: var(--_facet-2__onDark--xl, none);
  }

  .image__facet-2 {
    ::slotted(img), ::slotted(picture) {
      object-fit: cover;
        clip-path: var(--clip-path-facet-2--default);
        aspect-ratio: 1;
        width: var(--image__facet-2__width);
        height: auto;
        margin: var(--image__facet-2__margin);
      z-index: 2;
    }
  }

    .image-facet-2-md {
        display: var(--facet-2-md__display--lg);
    }
    .image-facet-2-lg {
        display: var(--facet-2-lg__display--lg);
        position: absolute;
        top: 0.5%;
        left: -7.3%;
        width: 110%;
        height: auto;
        z-index: 1;
    }
  .image-facet-2__onDark {
    display: var(--facet-2__onDark);
    position: absolute;
      top: -0.2%;
      left: -0.3%;
      width: 122%;
    height: auto;
    z-index: 3;
  }

    .image__facet-2--crop-mobile {
        ::slotted(img), ::slotted(picture) {
            clip-path: var(--facet-2__clip-path--mobile);
            aspect-ratio: var(--facet-2__aspect-ratio--mobile);
            width: var(--facet-2__width--mobile);
            margin: var(--facet-2__margin--mobile);
        }
        .image-facet-2-md {
            display: var(--facet-2-md__display--md);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: auto;
            z-index: 1;
        }
        .image-facet-2-lg {
            display: var(--facet-2-lg__display--md);
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                clip-path: var(--clip-path-facet-2--default);
                aspect-ratio: 1;
                width: var(--image__facet-2__width);
                margin: var(--image__facet-2__margin);
            }

            .image-facet-2-md {
                display: var(--facet-2-md__display--lg);
            }

            .image-facet-2-lg {
                display: var(--facet-2-lg__display--lg);
            }
        }
    }
`;
